import Ajax from "../utils/ajax";

export default {
  namespaced: true,
  state: {
    token:"",
    refreshToken: "",
    roles: [],
    user: {
      id: "",
      firstName: "",
      lastName: "",
      email: ""
    },

  },
  mutations: {
    
    SET_LOGIN(state, payload){
     state.token = payload.token;
     state.refreshToken = payload.refreshToken;
     state.user.id = payload.user.id;
     state.user.firstName = payload.user.firstName;
     state.user.lastName = payload.user.lastName;
     state.user.email = payload.user.email;
     state.roles = payload.roles;
    },
    SET_TOKENS(state, payload){
          state.token = payload.token;
          state.refreshToken = payload.refreshToken;
    },
    RESETLOGIN(state){
      state.token = "";
      state.refreshToken = "";
      state.user.id = "";
      state.user.firstName = "";
      state.user.lastName ="";
      state.user.email = "";
      state.roles = [];
    }
  },
  actions: {
    async auth({ commit }, { data }) {
      try {
        const resp = await Ajax.post("/api/v1/Auth/SignIn", data);

        commit("SET_LOGIN", resp.data.response); 

        return Promise.resolve(resp.data);
      } catch (e) {
        console.log(e)
        return Promise.reject(e.response.data);
      }
    },

    async logup({ commit }, { data }) {
      try {
        const resp = await Ajax.post("/api/v1/Auth/SignUp", data);

        return Promise.resolve(resp.data);
      } catch (e) {
  
        return Promise.reject(e.response.data);
      }
    },

    async revokeToken({ commit }, { data }) {
      try {
        const resp = await Ajax.post("/api/v1/Auth/revoke-token", data);

        return Promise.resolve(resp.data);
      } catch (e) {
  
        return Promise.reject(e.response.data);
      }
    },

  },
};
